export default "__VITE_ASSET__D$Q3kaE0__"